module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAVCAYAAACt4nWrAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtUlEQVQ4jbXV0Q3CIBSF4R/iu26iI9QN3EBHADsHuY6gm3QEu4lOgC+maVOIEi7nraT5Trgp1MQYaZXNrxe87+/A+ft4FAnDv7gtgIuTxRPwCDyr8QzciYRXFa4Fr3BNeIFrwxPeAgYwzl0dIDVIIm+gs8BOGQbYAjcLVG09kxE4mRhjs5lbAJFwAR6z9T0weN9XjWz6FFsULA6RdsHq+GsWJC8urYLslZspOKjgmYKimJb/0A81gl1iFSEKGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/back_button_icon.png
// module id = EE4e
// module chunks = 0